module.exports = __webpack_public_path__ + "static/media/pa.c680ae03.webp";